angular.module('Itao.IndicatorMap').directive('chartIndicatorLegend', function (d3, mapConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'chartIndicatorLegend.html',
    scope: {
      indicators: '=',
      disabledIndicators: '='
    },
    link: function(scope) {

      /**
       * toggle one indicator of the currently selected indicators
       *
       * @param {String} indicatorKey the indicator to toggle
       */
      scope.toggleIndicator = function(indicatorKey) {
        var index = scope.disabledIndicators.indexOf(indicatorKey);
        if(index > -1) {
          scope.disabledIndicators.splice(index, 1);
        } else {
          scope.disabledIndicators.push(indicatorKey);
        }
      };

      /**
       * get a color from the colorset by number
       * @param {int} number the index of the color
       * @returns {String} the color code
       */
      scope.color = function(number) {
        return d3.hyperion.indicatorColorAt(number);
      };
    }
  };
});
